<div class="theme-toggle-container" *ngIf="isOnCollectionRoute">
    <button class="theme-btn" [class.active]="isDark" (click)="setTheme('dark-theme')"
        aria-label="Switch to dark mode">
        Dark
    </button>
    <button class="theme-btn" [class.active]="isLight" (click)="setTheme('light-theme')"
        aria-label="Switch to light mode">
        Light
    </button>
</div>